import axios from 'axios';

export const getVolumeBackups = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/backups/detail`, settings);
}

export const createVolumeBackup = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/backups`, data, settings);
}

export const deleteVolumeBackup = async (apiUrl, backup_id, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/backups/${backup_id}`, settings);
}

export const restoreVolumeBackup = async (apiUrl, backup_id, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/backups/${backup_id}/restore`, data, settings);
}

export const getVolumeBackupDetails = async (apiUrl, backupId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/backups/${backupId}`, settings);
}